import { Component } from "@angular/core";
import { MakeProvider } from "../abstract-custom-control";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { BaseDataService } from "../../base-services/base-data.service";

@Component({
    selector: 'fotgotten-password',
    templateUrl: './forgotten-password.component.html',
    providers: [ MakeProvider(ForgottenPasswordComponent)]
})
export class ForgottenPasswordComponent {
    constructor(private baseDataService: BaseDataService){
    }

    forgottenPasswordFormGroup: FormGroup = new FormGroup({
        Username: new FormControl('', [ Validators.required, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$') ])
    });

    submitted: boolean = false;
    response: boolean;
    sendingRequest: boolean = false;

    SendPasswordResetRequest(username: string) {
        this.submitted = true;
        if(this.forgottenPasswordFormGroup.valid){
            this.sendingRequest = true;
            this.baseDataService.GetData('account', 'forgotPassword', { Email: username })
                .subscribe((response: boolean) => {
                    this.response = response;
                    this.sendingRequest = false;
                }, error => {
                    this.response = false;
                    this.sendingRequest = false;
                })
            }
    }
}